import * as React from "react";
import { IconProps } from "./types";

export default function PersonalizedMatches({ svgProps }: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <path
        fill="currentColor"
        d="M33.5 7.72 34.93 13.93 41.72 17.93 34.93 21.93 33.5 28.72 31.93 21.93 25.71 17.93 31.93 13.93 33.5 7.72Z"
      />
      <circle cx="21" cy="21" r="7" stroke="currentColor" strokeWidth="2" />
      <path
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m12 42 4-17h13l5 17"
      />
    </svg>
  );
}
